import { EditFieldBase } from './edit-field-base.model';
import { EditFieldDate } from './edit-field-date.model';
import { EditFieldDropdown } from './edit-field-dropdown.model';
import { EditFieldMetadataTypeEnum } from './edit-field-metadata-type.enum.model';
import { EditFieldTextbox } from './edit-field-textbox.model';
import { EditFieldsEnum } from './edit-field.model';

export const generalDetailsEditFields: EditFieldBase<any>[] = [
    new EditFieldDropdown({
        key: EditFieldsEnum.ModeOfTransport,
        i18nText: 'concepts.declarations.massAdjustments.general_details.mode_of_transport',
        metadataType: EditFieldMetadataTypeEnum.ModeOfTransport,
        required: true,
        order: 1
    }),
    new EditFieldDate({
        key: EditFieldsEnum.ReleaseDate,
        i18nText: 'concepts.declarations.massAdjustments.general_details.release_date',
        required: true,
        order: 2
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PreviousTransactionNumber,
        i18nText: 'concepts.declarations.massAdjustments.general_details.previous_transaction_number',
        required: true,
        order: 3
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.PortOfUnladingRegion,
        i18nText: 'concepts.declarations.massAdjustments.general_details.port_of_unlading_region',
        metadataType: EditFieldMetadataTypeEnum.PortOfUnladingRegion,
        required: true,
        order: 4
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.PortOfUnlading,
        i18nText: 'concepts.declarations.massAdjustments.general_details.port_of_unlading',
        metadataType: EditFieldMetadataTypeEnum.PortOfUnlading,
        required: true,
        order: 5
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.CarrierCode,
        i18nText: 'concepts.declarations.massAdjustments.general_details.carrier_code',
        required: true,
        order: 6
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.CargoControl,
        i18nText: 'concepts.declarations.massAdjustments.general_details.cargo_control',
        required: true,
        order: 7
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.GrossWeight,
        i18nText: 'concepts.declarations.massAdjustments.general_details.gross_weight',
        required: true,
        order: 8
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.FreightCharges,
        i18nText: 'concepts.declarations.massAdjustments.general_details.freight_charges',
        required: true,
        order: 9
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.WarehouseNumberComingIn,
        i18nText: 'concepts.declarations.massAdjustments.general_details.warehouse_number_coming_in',
        required: true,
        order: 10
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.WarehouseNumberComingOut,
        i18nText: 'concepts.declarations.massAdjustments.general_details.warehouse_number_coming_out',
        required: true,
        order: 11
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PreviousTransactionNumberWarehouse,
        i18nText: 'concepts.declarations.massAdjustments.general_details.previous_transaction_number_warehouse',
        required: true,
        order: 12
    }),
];
